export const BILLING_TAB = 'billing';
export const GENERAL_INFO_TAB = 'generalInfo';
export const TAX_INFO_TAB = 'taxInfo';

export const tabsAndSections = [
	{
		name: GENERAL_INFO_TAB,
		sections: [
			'contact',
			'password',
			'language',
			'timezone',
			'dateTime',
			'closeAccount'
		]
	},
	{
		name: TAX_INFO_TAB,
		sections: ['taxInfo']
	},
	{
		name: BILLING_TAB,
		sections: ['billing'],
		showUpdatedBanner: false
	}
];
